import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { Globals } from 'src/app/shared/globals/globals';
import { CustomerSpecialRequirement, EnquiryAttachment, EnquiryHeader, EnquiryHeaderItem } from 'src/app/shared/models/data/enquiry.model';
import { HeaderParametersValues } from 'src/app/shared/models/data/headerParametersValues.model';
import { HistoryByEnquiry, HistoryRecords } from 'src/app/shared/models/data/historyByEnquiry.model';
import { ItemAttachment, Items, ItemsByEnquiryNo } from 'src/app/shared/models/data/itemsByEnquiryNo.model';
import { RoundDigit } from 'src/app/shared/models/data/roundDigit.model';
import { BackendService } from 'src/app/shared/services/backend/backend.service';
import { TeiasoftLoaderService } from 'src/app/shared/services/teiasoft-bucket/teiasoft-loader.service';
import { UtilsService } from 'src/app/shared/services/utils/utils.service';
import { ColumnWidth, GridConfiguration } from 'src/app/shared/teiasoft-bucket/teiasoft-grid-odata/teiasoft-grid-odata.component';
import { CalculatedCols, ClickedCell, CustomIcoCol, GridDataset } from 'src/app/shared/teiasoft-bucket/teiasoft-grid/teiasoft-grid.component';
import { CustomIcoCol as OdataCustomIcoCol } from 'src/app/shared/teiasoft-bucket/teiasoft-grid-odata/teiasoft-grid-odata.component';

import { TTButton } from 'src/app/shared/teiasoft-bucket/teiasoft-toolbar/teiasoft-toolbar.component';
import { TranslateService } from '@ngx-translate/core';
import { parseGridActionEvent } from 'src/app/shared/utils/grid-event.utils';
declare var $: any;

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss']
})
export class HistoryComponent implements OnInit, OnDestroy {
  buttonsList: TTButton[] = new Array();
  gridFilterable: boolean = false;
  clearFilters: boolean = false;
  columnsToHide: string[] = ["EnquiryId", "UserId", "QuotationExists", "IsQuotationFinal", 'OdUom', 'IdUom', 'WtUom', 'TotalWeightUom', 'BookedTotalWeightUom', 'TotalBookedWeightUom','AlloySurcharge'];

  oDataUrl: string = "History";
  gridConfiguration: GridConfiguration = new GridConfiguration();
  refreshGridKey: number = 0;
  showSettingsDialog: boolean = false;
  columnsWidth: ColumnWidth[] = new Array();
  showHistoryDetail: boolean = false;
  historyRecords: HistoryRecords[] = new Array();
  columnsToShowDetail: string[] = ["logTimestamp", "user", "action", "description","customerItemNo"];
  minWidthVw: number = 0;
  columnsToShowItems: string[] = ["customerItemNo", "feasibilityStatus", "costsStatus", "deliveryStatus", "unitSystem", "material.materialCode", "sms.marketingRoute", "sms.description", "marketFamily.name", "customerDeliveryDate", "energySurcharge", "applicableNorms", "remark", "normGrades.normGradeCode", "gradeCustomerAnalysisLimitation.limitation",
    "gradeCustomerOtherLimitation.limitation", "rawMaterialGrade.rawMaterialGradeCode", "npsSchedule.npsDescription", "od", "odTolerancePlus", "odToleranceMinus", "odToleranceUom", "id", "idTolerancePlus", "idToleranceMinus", "idToleranceUom", "wt", "typeOfTolerance", "tubeExecution.description", "wtTolerancePlus", "wtToleranceMinus", "wtToleranceUom",
    "quantity", "quantityUom", "lengthType", "multipleLength", "lengthMin", "lengthMax", "lengthNominal", "uBent", "totalWeight", "totalWeightUom", "mill.shortName", "surfaceType.name", "cts", "endsCondition", "testCondition", "sql.name", "offerScheme.offerSchemeDescription", "ut", "hydroTest", "ht", "htAdditional", 'dyePenetrant', 'dyePenetrant100P', 'penalty', 'colorCoding', 'specialOperations', 'specialTests', 'grindingHoning', 'ec', 'notStdPackaging', 'inspectionType3Dot2', 'multipleCutting',
    "icrIssued", "itrIssued", "idrIssued", "attachments", "fullCost", "extraCosts", "minimumFm", "recommendedFm", "customerBonus", "minimumPrice", "recommendedPrice", "actualFm", "actualFmAmountPerWeight", "negotiationMargin", "agentFee", "finalPrice", "finalPricePerLength", "totalPrice", 'alloySurchargeValue', 'energySurchargeValue', "initialPrice", "previousRevisionPrice", "extraLeadTime", 'deliveryDate', 'isBooked'];

  dataSetItems: any[] = new Array();
  calculatedCols: CustomIcoCol[] = new Array();
  itemAttachments: ItemAttachment[] = new Array();
  showAttachments: boolean = false;
  enquiryItems: ItemsByEnquiryNo = new ItemsByEnquiryNo();
  roundDigitsForGrid: RoundDigit[] = new Array();
  enquiryAttachments: EnquiryAttachment[] = new Array();
  headerParametersValues: HeaderParametersValues = new HeaderParametersValues();
  top: number = 0;
  subscriptions = new Subscription();
  initComplete: boolean = false;
  selectedEnquiryNo?: string;
  selectedEnquiryHeader?: EnquiryHeader;
  customIcoCols: OdataCustomIcoCol[] = new Array();
  showExtraCosts: boolean = false;
  selectedExtraCostItem?: EnquiryHeaderItem;

  showItemDeliveryDates: boolean = false;
  selectedDeliveryDatesItem?: EnquiryHeaderItem;

  showSpecialRequirements: boolean = false;
  customerSpecialRequirements: CustomerSpecialRequirement[] = [];
  private documentScrollHandler: (() => void) | null = null;

  @ViewChild('viewCostHeader', { static: true }) viewCostHeader!: TemplateRef<any>;
  @ViewChild('viewCost', { static: true }) viewCostTemplate!: TemplateRef<any>;
  @ViewChild('viewExtraCosts', { static: true }) viewExtraCostsTemplate!: TemplateRef<any>;
  @ViewChild('viewDeliveryDates', { static: true }) viewDeliveryDates!: TemplateRef<any>;

  private readonly costHeaderUomByColumn: { [key: string]: string } = {
    initialPrice: 'costsUom',
    previousRevisionPrice: 'costsUom',
    finalPricePerLength: 'finalPricePerLengthUom',
    totalPrice: 'totalPriceUom',
    alloySurchargeValue: 'costsUom',
    energySurchargeValue: 'costsUom',
    fullCost: 'costsUom',
    minimumPrice: 'costsUom',
    recommendedPrice: 'costsUom',
    extraCosts: 'costsUom',
    finalPrice: 'costsUom',
    actualFmAmountPerWeight: 'costsUom'
  };

  customHeaderRenderers = {
    initialPrice: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'initialPrice' }
      };
    },
    previousRevisionPrice: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'previousRevisionPrice' }
      };
    },
    finalPricePerLength: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'finalPricePerLength' }
      };
    },
    totalPrice: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'totalPrice' }
      };
    },
    alloySurchargeValue: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'alloySurchargeValue' }
      };
    },
    energySurchargeValue: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'energySurchargeValue' }
      };
    },
    fullCost: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'fullCost' }
      };
    },
    minimumPrice: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'minimumPrice' }
      };
    },
    recommendedPrice: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'recommendedPrice' }
      };
    },
    extraCosts: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'extraCosts' }
      };
    },
    finalPrice: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'finalPrice' }
      };
    },
    actualFmAmountPerWeight: () => {
      return {
        template: this.viewCostHeader,
        context: { column: 'actualFmAmountPerWeight' }
      };
    }
  };

  customRenderers = {
    initialPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'initialPrice' }
      };
    },
    previousRevisionPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'previousRevisionPrice' }
      };
    },
    finalPricePerLength: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'finalPricePerLength', uomColumn: 'finalPricePerLengthUom' }
      };
    },
    totalPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'totalPrice', uomColumn: 'totalPriceUom' }
      };
    },
    deliveryDate: (row: any) => {
      return {
        template: this.viewDeliveryDates,
        context: { $implicit: row, column: 'delilveryDate' }
      };
    },
    alloySurchargeValue: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'alloySurchargeValue' }
      };
    },
    energySurchargeValue: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'energySurchargeValue' }
      };
    },
    fullCost: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'fullCost' }
      };
    },
    minimumPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'minimumPrice' }
      };
    },
    recommendedPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'recommendedPrice' }
      };
    },
    extraCosts: (row: any) => {
      return {
        template: this.viewExtraCostsTemplate,
        context: { $implicit: row, column: 'extraCosts' }
      };
    },
    finalPrice: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'finalPrice' }
      };
    },
    actualFmAmountPerWeight: (row: any) => {
      return {
        template: this.viewCostTemplate,
        context: { $implicit: row, column: 'actualFmAmountPerWeight' }
      };
    }
  };

  constructor(public globals: Globals, private backendService: BackendService,
    private teiasoftLoader: TeiasoftLoaderService, private utils: UtilsService, private translate: TranslateService) {
    this.documentScrollHandler = () => {
      this.top = $(document).scrollTop();
    };
    $(document).on("scroll", this.documentScrollHandler);

    this.getRoundDigits();
    this.setColumnsWidth();
    this.checkUserConfiguration();
  }

  ngOnInit(): void {
    this.buildCustomIconGrid();
    this.getHeaderParametersValues().then(() => this.initComplete = true);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    if (this.documentScrollHandler) {
      $(document).off("scroll", this.documentScrollHandler);
      this.documentScrollHandler = null;
    }
  }

  getCostColumnHeaderLabel(column: string): string {
    const baseLabel = this.getTranslatedColumnLabelWithoutUom(column);
    const uomColumn = this.costHeaderUomByColumn[column];
    const uomValue = this.getCostColumnUom(uomColumn);
    return uomValue ? `${baseLabel} (${uomValue})` : baseLabel;
  }

  private getCostColumnUom(uomColumn?: string): string {
    if (!uomColumn) {
      return '';
    }

    const fromGrid = this.dataSetItems.find(item => !!item?.[uomColumn])?.[uomColumn];
    if (fromGrid) {
      return fromGrid;
    }

    const fromItems = this.enquiryItems?.items?.find(item => !!(item as any)?.[uomColumn]) as any;
    return fromItems?.[uomColumn] ?? '';
  }

  private getTranslatedColumnLabelWithoutUom(column: string): string {
    const translationKey = 'grid.' + column.charAt(0).toUpperCase() + column.slice(1);
    const translatedLabel = this.translate.instant(translationKey);
    return this.stripHardcodedUomSuffix(translatedLabel);
  }

  private stripHardcodedUomSuffix(label: string): string {
    return (label || '').replace(/\s*\(?[^\s()]+\/[^\s()]+\)?\s*$/, '').trim();
  }

  buildCustomIconGrid() {
    this.customIcoCols = new Array();
    let _item: OdataCustomIcoCol = new OdataCustomIcoCol();

    /* QUOTATION DOWNLOAD */
    _item = new OdataCustomIcoCol();
    _item.action = "downloadQuotation";
    _item.getIcon = (row: any) => {
      if (row.QuotationExists)
        return row.IsQuotationFinal ? ['fa-light fa-file-circle-check'] : ['fa-light fa-file-lines'];
      return ['']
    };
    _item.getTooltip = (row: any) => row.IsQuotationFinal ? this.translate.instant("quotation.download") : this.translate.instant("quotation.downloadDraft");
    _item.position = "start";
    _item.disabled = false;
    _item.isMenu = false;
    this.customIcoCols.push(_item);

  }

  customIconClick(evt: any) {
    if (evt.indexOf("|") != -1) {
      const { action: _action, row: _obj } = parseGridActionEvent(evt);
      if (_action == 'downloadQuotation') {
        const enquiryNo = _obj["EnquiryNo"];
        this.teiasoftLoader.start();
        this.subscriptions.add(this.backendService.getQuotationPdf(enquiryNo).subscribe({
          next: (val) => {
            this.downloadQuotationPdf(val, enquiryNo);
          },
          complete: () => {
            this.teiasoftLoader.stop();
          }
        }))
      }

    }
  }

  private downloadQuotationPdf(val: any, enquiryNo: string) {
    const base64String = val.quotationPdf;
    const binaryData = window.atob(base64String);
    const arrayBuffer = new Uint8Array(binaryData.length);

    for (let i = 0; i < binaryData.length; i++) {
      arrayBuffer[i] = binaryData.charCodeAt(i);
    }

    const blob = new Blob([arrayBuffer], { type: 'application/pdf' });

    const downloadLink = document.createElement('a');
    downloadLink.href = window.URL.createObjectURL(blob);
    downloadLink.download = `Quotation ${enquiryNo}`;

    downloadLink.click();

    window.URL.revokeObjectURL(downloadLink.href);
  }

  getHeaderParametersValues(): Promise<void> {
    this.teiasoftLoader.start();
    return new Promise((resolve, reject) => {
      this.subscriptions.add(this.backendService.getHeaderParametersValues().subscribe(res => {
        this.headerParametersValues = new HeaderParametersValues();
        if (res) {
          res.countries?.sort((a, b) => {
            if (a.countryName! < b.countryName!) {
              return -1;
            }
            if (a.countryName! > b.countryName!) {
              return 1;
            }
            return 0;
          });
          this.headerParametersValues = res;
        }
        resolve();
      },
        err => {
          reject(err);
        }
      ));
    }
    );
  }

  getRoundDigits() {
    this.teiasoftLoader.start();
    this.utils.getRoundDigits().subscribe(res => {
      this.roundDigitsForGrid = new Array();
      this.roundDigitsForGrid = res.filter(x => x.section == 'Enquiries' && x.api == 'GetEnquiries');
    });
  }

  /**
   * SET COLUMNS WIDTH
   */
  setColumnsWidth() {
    this.columnsWidth = new Array();
    let _col: ColumnWidth = new ColumnWidth();
    _col.colName = "CustomerName";
    _col.length = 100;
    _col.width = 100;
    this.columnsWidth.push(_col);

    _col = new ColumnWidth();
    _col.colName = "ApplicableNorms";
    _col.length = 100;
    _col.width = 100;
    this.columnsWidth.push(_col);
  }

  /**
   * CHECK USER GRID CONFIGURATION
   */
  checkUserConfiguration() {
    this.gridConfiguration = new GridConfiguration();
    const userConfiguration = this.utils.getUserConfiguration();
    const savedConfiguration = userConfiguration.gridsConfigurations?.find(cfg => (cfg.name ?? '').toLowerCase() === 'history');
    if (savedConfiguration) {
      this.gridConfiguration = savedConfiguration;
    } else {
      this.gridConfiguration.name = 'History';
      this.gridConfiguration.gridColumns = [];
      this.gridConfiguration.defaultFilterView = '';
    }
    if (!this.gridConfiguration.name) this.gridConfiguration.name = 'History';

    /* BUILD BUTTONS FOR TOOLBAR */
    this.buildButtonsList();
  }

  updateUserConfiguration() {
    this.backendService.updateUserConfiguration(this.globals.userLogged!.configuration!, this.globals.userLogged!.language!, this.globals.userLogged!.dateFormat!).subscribe(res => {
      // HI - 7/12/2023 - Rif. MQF-03 - Commentato
      //this.teiasoftToaster.show("success", this.translate.instant("commons.success"));
      // END MQF-03
    });
  }

  /**
   * REFRESH GRID
   */
  refreshFullGrid() {
    this.refreshGridKey++;
  }

  getHistoryByEnquiry(enquiryId: number, enquiryNo: string) {
    this.teiasoftLoader.start();
    this.backendService.getHistoryByEnquiry(enquiryId).subscribe(res => {
      //this.teiasoftLoader.stop();
      if (res) {
        this.historyRecords = new Array();
        // MQF-414 - order By LogId
        this.historyRecords = res.historyRecords!.sort((a: any, b: any) => {
          return b["logId"] - a["logId"];
        });


        console.log("HISTORY RECORDS", this.historyRecords);


        this.showHistoryDetail = true;
        //let _w: number = $('.cnt-detail').width();
        this.minWidthVw = 94.2;
        this.buildCalculatedCols();
        this.getItemsByEnquiryNo(enquiryNo);
      }
    });
  }

  getItemsByEnquiryNo(enquiryNo: string) {
    this.backendService.getItemsByEnquiryNo(enquiryNo).subscribe(res => {
      this.teiasoftLoader.stop();
      this.enquiryItems = new ItemsByEnquiryNo();
      this.enquiryItems = JSON.parse(JSON.stringify(res));
      this.fillDataSetItems(res);
    });
  }

  fillDataSetItems(enquiryItems: ItemsByEnquiryNo) {
    this.dataSetItems = new Array();
    for (var i = 0; i < enquiryItems.items!.length; i++) {
      let _dataSet: GridDataset = new GridDataset();
      let _obj: Items = new Items();
      _obj = enquiryItems.items![i]!;
      for (const key in _obj) {
        let _value: any = _obj[key as keyof typeof _obj];
        if (_value == null) _value = "";
        let _typeOf: string = typeof _value;
        let _key: string = "";
        if (_typeOf != 'object') {
          _dataSet[key] = _value;
        } else {
          if (Array.isArray(_value)) {
            _key = key;
            if (_value.length == 0) {
              _dataSet[_key] = '';
            }
            if (_value.length > 0 && key.toLowerCase() == 'attachments') {
              _dataSet[_key] = _value.length;
            } else {
              for (const key2 in _value[0]) {
                _key = key + "." + key2;
                //_dataSet[key2] = _value.map(x => x[key2]).join(',');
                _dataSet[_key] = _value.map(x => x[key2]).join(',');
              }
            }

          } else {
            for (const key3 in _value) {
              if (typeof _value[key3] != 'object') {
                _key = key + "." + key3;
                let _value3: any = _value[key3 as keyof typeof _value];
                //_dataSet[key3] = _value3;
                _dataSet[_key] = _value3;
              } else {
                for (const key4 in _value[key3]) {
                  _key = key + "." + key3 + "." + key4;
                  let _value4: any = _value[key3][key4]; //_value[key4 as keyof typeof key4];
                  //_dataSet[key4] = _value4;
                  _dataSet[_key] = _value4;
                }
              }
            }
          }
        }
      }
      this.dataSetItems.push(_dataSet);
    }
    this.dataSetItems = this.dataSetItems.sort(
      function (a, b) {
        return a["itemNo"]! - b["itemNo"]!;
      }
    );

    this.teiasoftLoader.stop();
  }

  buildCalculatedCols() {
    this.calculatedCols = new Array();
    /* FEASIBILITY CALCULATED COL */
    let _item: CalculatedCols = new CalculatedCols();
    _item.id = 0;
    _item.icon = '';
    _item.method = 'calculateItemsValidity|FeasibilityStatus';
    _item.tooltip = '';
    _item.position = 'start';
    _item.header = "F";
    this.calculatedCols.push(_item);

    /* PRICE CALCULATED COL */
    _item = new CalculatedCols();
    _item.id = 1;
    _item.icon = '';
    _item.method = 'calculateItemsValidity|CostsStatus';
    _item.tooltip = '';
    _item.position = 'start';
    _item.header = "P";
    this.calculatedCols.push(_item);

    /* DELIVERY CALCULATED COL */
    _item = new CalculatedCols();
    _item.id = 2;
    _item.icon = '';
    _item.method = 'calculateItemsValidity|DeliveryStatus';
    _item.tooltip = '';
    _item.position = 'start';
    _item.header = "D";
    this.calculatedCols.push(_item);

  }

  /**
   * TOOLBAR
   */
  buildButtonsList() {
    this.buttonsList = new Array();
    /* ALL */
    let _item: TTButton = new TTButton();

    /* EDIT GRID */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = 'fal fa-wrench';
    _item.id = 4;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "editGrid";
    _item.action = "showSettingsGrid";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

    /* SHOW/HIDE FILTER */
    _item = new TTButton();
    _item.disabled = false;
    _item.icon = !this.gridFilterable ? 'fal fa-filter' : 'fal fa-filter-circle-xmark';
    _item.id = 5;
    _item.size = "";
    _item.text = "";
    _item.tooltip = !this.gridFilterable ? "showGridFilters" : "hideGridFilters";
    _item.action = !this.gridFilterable ? "showFilter" : "closeFilter";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);

    /* CLEAR FILTERS */
    _item = new TTButton();
    _item.disabled = !this.gridFilterable ? true : false;
    _item.icon = 'fal fa-eraser';
    _item.id = 6;
    _item.size = "";
    _item.text = "";
    _item.tooltip = "clearGridFilters";
    _item.action = "clearFilter";
    _item.type = "";
    _item.state = '';
    this.buttonsList.push(_item);
  }

  onBtnToolbarClick(btn: TTButton) {
    /* ALL ENQUIRIES / MY ENQUIRIES / OFFICE ENQUIRIES */
    if (btn.action!.indexOf('filter') != -1) {
      let _temp: string[] = new Array();
      _temp = btn.action!.split("|");
      this.gridConfiguration.defaultFilterView = _temp[1];
      this.onUpdateConfiguration(this.gridConfiguration);
      this.refreshFullGrid();
    }

    /* SHOW SETTINGS GRID */
    if (btn.action == 'showSettingsGrid') {
      this.showSettingsDialog = true;
    }

    /* SHOW FILTER */
    if (btn.action == 'showFilter') {
      this.gridFilterable = true;
      this.buildButtonsList();
    }

    /* CLOSE FILTER */
    if (btn.action == 'closeFilter') {
      this.gridFilterable = false;
      this.buildButtonsList();
    }

    /* CLEAR FILTER */
    if (btn.action == 'clearFilter') {
      this.clearFilters = true;
      setTimeout(() => { this.clearFilters = false }, 250);
      this.refreshFullGrid();
    }

  }

  onUpdateConfiguration(gridConfiguration: GridConfiguration) {
    const updatedConfiguration: GridConfiguration = { ...gridConfiguration, name: 'History' };
    this.gridConfiguration = updatedConfiguration;
    this.utils.upsertGridConfiguration(updatedConfiguration);
    this.updateUserConfiguration();
  }

  /* GRID */
  rowsSelected(rows: any) {
    if (rows.length > 0) {
      this.selectedEnquiryNo = rows[0]["EnquiryNo"];
      this.selectedEnquiryHeader = {
        enquiryNo: rows[0]["EnquiryNo"],
        currency: rows[0]["Currency"] ?? rows[0]["currency"],
        unitSystem: rows[0]["UnitSystem"] ?? rows[0]["unitSystem"]
      };
      this.getHistoryByEnquiry(rows[0]["EnquiryId"], rows[0]["EnquiryNo"]);
    } else {
      this.historyRecords = new Array();
      this.showHistoryDetail = false;
      this.selectedEnquiryNo = undefined;
      this.selectedEnquiryHeader = undefined;
    }
  }

  /* GRID CELL CLICK */
  onCellClick(cell: ClickedCell) {
    $('body').css('overflow-y', 'hidden');
    if (cell.colName?.toLowerCase() == 'attachments') {
      let _itemNo: string = JSON.parse(cell.row)["itemNo"];
      this.itemAttachments = new Array();
      this.itemAttachments = JSON.parse(JSON.stringify(this.enquiryItems!.items!.find(x => x.itemNo == _itemNo)!.attachments!));
      this.showAttachments = true;
    }

    if (cell.colName == "NumberOfAttachments") {
      this.getEnquiryAttachments(cell.row["EnquiryNo"]);
    }

    if (cell.colName?.toLowerCase() == 'hascustomerspecialrequirements') {
      const enquiryNo: string = cell.row["EnquiryNo"];

      this.subscriptions.add(this.backendService.getEnquiryCustomerSpecialRequirements(enquiryNo).subscribe(res => {
        this.customerSpecialRequirements = res.customerSpecialRequirements;
        this.showSpecialRequirements = true;
      }));
    }
  }

  getEnquiryAttachments(enquiryNo: string) {
    this.teiasoftLoader.start();
    this.backendService.getEnquiryAttachments(enquiryNo).subscribe(res => {
      this.teiasoftLoader.stop();
      this.enquiryAttachments = new Array();
      this.enquiryAttachments = JSON.parse(JSON.stringify(res["enquiryAttachments"]));
      this.showAttachments = true;
    });
  }

  onCloseAttachments(evt: any) {
    $('body').css('overflow-y', 'auto');
    this.showAttachments = false;
    this.itemAttachments = new Array();
  }

  onItemExtraCostsClick(item: EnquiryHeaderItem) {
    this.selectedExtraCostItem = item;
    this.showExtraCosts = true;
  }

  onItemDeliveryDatesClick(item: EnquiryHeaderItem) {
    this.selectedDeliveryDatesItem = this.enquiryItems.items?.find(i => i.itemNo == item.itemNo);
    this.showItemDeliveryDates = true;
  }

  getItemRowMinDeliveryDate(row: EnquiryHeaderItem): string {
    const item = this.enquiryItems.items?.find(i => i.itemNo === row.itemNo) as EnquiryHeaderItem;

    // Get minimum weeks value
    const minWeeks = item?.deliveryDatesCollection
      ?.map(dd => dd.deliveryNumberOfWeeksWithExtraLeadTime)
      .filter(weeks => typeof weeks === 'number' && weeks > 0)
      .reduce((min, current) => Math.min(min!, current!), Infinity);

    return minWeeks === Infinity ? '' : this.formatWeeks(minWeeks!);
  }

  formatWeeks(weeks: number): string {
    return `${weeks} week${weeks > 1 ? 's' : ''}`;
  }

  getItemRowDeliveryDatesCollection(row: EnquiryHeaderItem) {
    const item = this.enquiryItems.items?.find(i => i.itemNo == row.itemNo) as EnquiryHeaderItem;

    return item.deliveryDatesCollection || [];
  }

  formatDate(date: number) {
    return this.utils.formatDate(date);
  }

  formatWeekDate(dateMillis: number) {
    const date = new Date(dateMillis);
    if (isNaN(date.getTime())) return '';

    // Get full year and last two digits
    const fullYear = date.getFullYear();
    const yearSuffix = fullYear.toString().slice(-2);

    const firstJan = new Date(fullYear, 0, 1);
    const diffDays = Math.floor((date.getTime() - firstJan.getTime()) / (1000 * 60 * 60 * 24));
    const weekNumber = Math.ceil((diffDays + firstJan.getDay() + 1) / 7);

    return `W${weekNumber}-${yearSuffix}`;
  }
}
